// What's New content, keyed by "Major.Minor".
// Add an entry here whenever shipping a minor or major version bump.
// Patch versions (1.4.0 → 1.4.1) never need an entry.
const WHATS_NEW_CONTENT = {
  "1.10": {
    titleKey: "whats_new_1_10_title",
    items: [
      "whats_new_1_10_item1",
      "whats_new_1_10_item2",
      "whats_new_1_10_item3",
    ],
  },
  "1.9": {
    titleKey: "whats_new_1_9_title",
    items: [
      "whats_new_1_9_item1",
      "whats_new_1_9_item2",
      "whats_new_1_9_item5",
      "whats_new_1_9_item3",
      "whats_new_1_9_item4",
    ],
  },
  "1.8": {
    titleKey: "whats_new_1_8_title",
    items: [
      "whats_new_1_8_item1",
      "whats_new_1_8_item2",
      "whats_new_1_8_item3",
      "whats_new_1_8_item4",
    ],
  },
  "1.7": {
    titleKey: "whats_new_1_7_title",
    items: [
      "whats_new_1_7_item1",
      "whats_new_1_7_item2",
      "whats_new_1_7_item3",
    ],
  },
  "1.6": {
    titleKey: "whats_new_1_6_title",
    items: [
      "whats_new_1_6_item1",
      "whats_new_1_6_item2",
      "whats_new_1_6_item3",
    ],
  },
  "1.5": {
    titleKey: "whats_new_1_5_title",
    items: [
      "whats_new_1_5_item1",
      "whats_new_1_5_item2",
      "whats_new_1_5_item3",

    ],
  },
  "1.4": {
    titleKey: "whats_new_1_4_title",
    items: [
      "whats_new_1_4_item1",
      "whats_new_1_4_item2",
    ],
  },
  "1.3": {
    titleKey: "whats_new_1_3_title",
    items: [
      "whats_new_1_3_item1",
      "whats_new_1_3_item2",
    ],
  },
};

export default WHATS_NEW_CONTENT;
